import React, { useEffect, useMemo, useState } from 'react';
import { ACCESS_TOKEN, IS_AUTHENTICATED, IS_DATA_RECEIVED } from '../stateManagment/gameState';
import { playerService } from '../services/PlayerService';
import { autoSpinHelper } from '../services/helperService/AutoSpinHelper';
import { iframeService } from '../services/IframeService';
import { httpClient } from '../core/httpClient';
import { PostMessageListenerMessages } from '../core/constats';

const platformMessagesWrapper = (token, isAuthDataReceived) => {
  httpClient.interceptors.request.use(
    (config) => {
      const accessToken = isAuthDataReceived && token ? `Bearer ${token}` : '';
      if (accessToken) {
        // eslint-disable-next-line no-param-reassign
        config.headers.authorization = accessToken;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export const PlatformMessagesWrapper = ({ children = [] }) => {
  const [, setIsAuth] = useState(IS_DATA_RECEIVED.getValue())
  const isAuthDataReceived = IS_DATA_RECEIVED.getValue()
  const additionalMessagesParams = useMemo(() => {
    return [
      {
        name: PostMessageListenerMessages.AuthInfoUpdate,
        callback: (data) => {
          const { accessToken, isAuthenticated } = data;
          IS_AUTHENTICATED.next(isAuthenticated);
          ACCESS_TOKEN.next(accessToken);
          IS_DATA_RECEIVED.next(true);
          platformMessagesWrapper(accessToken, true);
        },
      },
      {
        name: PostMessageListenerMessages.UpdateBalance,
        callback: () => {
          playerService.getBalance()
        },
      },
      {
        name: PostMessageListenerMessages.StopAutoSpins,
        callback: () => {
          autoSpinHelper.reset()
        },
      },
    ];
  }, []);

  useEffect(()=>{
    IS_DATA_RECEIVED.subscribe(setIsAuth)
  },[])

  useEffect(() => {
    iframeService.setPostMessageListener(additionalMessagesParams);
    iframeService.sendGetAuthInfo();
  }, [additionalMessagesParams]);
  return isAuthDataReceived ? children : <></>;
};